import { CircularProgress } from '@mui/material';
import React, { useEffect, useState } from 'react';

function TimesItem({
  time,
  disabled,
  selectedTimes,
  onTimesSelectItemClick,
}) {
  const timeExistsInList = (time, list) => {
    return list.includes(time);
  };

  const getItemStyle = () => {
    if (disabled) {
      return 'border-gray text-gray';
    } else if (timeExistsInList(time, selectedTimes)) {
      return 'bg-primary text-white hover:bg-primaryDark cursor-pointer';
    }
    return 'text-primary border-primary hover:text-white hover:bg-primary cursor-pointer';
  };

  return (
    <div
      className={`border-2 ${getItemStyle()} rounded-[20px] flex justify-center items-center text-2xl font-medium`}
      onClick={onTimesSelectItemClick}
    >
      {time}
    </div>
  );
}

export default function TimesSelect({
  times,
  disabledList,
  isHidden,
  isLoader,
  selectedTimes,
  setSelectedTimes,
  isError,
  error
}) {
  const timeExistsInList = (time, list) => {
    return list.includes(time);
  };

  const addItemToList = (item, list) => {
    return [...list, item];
  }

  const removeItemFromList = (item, list) => {
    return list.filter(i => i !== item);
  }

  return (
    <div className={`${isHidden && 'hidden'} ${isError && 'border-2 border-primary rounded-[20px]'}`}>
      {isLoader
      ? (<div className='w-full py-5 flex justify-center items-center'><CircularProgress sx={{color: '#A31732'}}/></div>)
      : (
        <>
          <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-2 gap-2'>
            {times.map((t) => {
              return (
                <TimesItem
                  key={t}
                  time={t}
                  disabled={timeExistsInList(t, disabledList)}
                  selectedTimes={selectedTimes}
                  onTimesSelectItemClick={() => {
                    if (!timeExistsInList(t, disabledList)) {
                      if (timeExistsInList(t, selectedTimes)) {
                        setSelectedTimes((prevState) => removeItemFromList(t, prevState));
                      } else {
                        setSelectedTimes((prevState) => addItemToList(t, prevState));
                      }
                    }
                  }}
                />
              );
            })}
          </div>
          <p className={`relative pl-5 font-medium text-xl text-primary ${isError ? 'block' : 'hidden'}`}>{error}</p>
        </>
      )}
    </div>
  );
}